import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { MobileStepper } from "@mui/material";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles(theme => ({
  root: {
    lineHeight: 0,
    position: "relative",
    boxShadow: "inset 0px -1px 2px rgba(0, 0, 0, 0.12)",
    paddingRight: theme.spacing(0.5)
  },
  image: {
    width: "100%",
    zIndex: 0
  },
  stepper: {
    position: "absolute",
    background: "none",
    left: "50%",
    marginLeft: -35,
    bottom: 6
  },
  dot: {
    backgroundColor: "rgba(255, 255, 255, 0.4)"
  },
  dotActive: {
    backgroundColor: theme.palette.common.white
  },
  swipeableView: {
    overflow: "hidden",
    "& > div > div": {
      "-ms-overflow-style": "none" // fix for scrollbar in IE
    }
  }
}));

export default function ImageCarousel(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  let { bannerImages, imgStyle } = props;
  bannerImages = (bannerImages || []).filter(image => !!image.imgPath);

  function handleStepChange(step) {
    setActiveStep(step);
  }
  function swipeImage() {
    setActiveStep(activeStep + 1 === bannerImages.length ? 0 : activeStep + 1);
  }

  return (
    <div data-qa="image-carousel" className={classes.root} onClick={swipeImage}>
      {bannerImages.length > 0 && (
        <AutoPlaySwipeableViews
          interval={5000}
          axis="x"
          index={activeStep}
          onChangeIndex={handleStepChange}
          className={classes.swipeableView}
        >
          {bannerImages.map((image, index) =>
            Math.abs(activeStep - index) <= 2 ? (
              <img
                key={index}
                alt="Banner"
                src={image.imgPath}
                className={classes.image}
                style={imgStyle}
              />
            ) : null
          )}
        </AutoPlaySwipeableViews>
      )}
      {bannerImages.length > 1 && (
        <MobileStepper
          variant="dots"
          steps={bannerImages.length}
          position="static"
          activeStep={activeStep}
          classes={{
            root: classes.stepper,
            dot: classes.dot,
            dotActive: classes.dotActive
          }}
        />
      )}
    </div>
  );
}

ImageCarousel.propTypes = {
  bannerImages: PropTypes.arrayOf(PropTypes.any),
  imageStyle: PropTypes.object
};
